(function($, Drupal) {
  if (typeof modal != 'undefined') {
    const expirationDuration = 1000 * 60;
    const prevAccepted = localStorage.getItem('accepted');
    const currentTime = new Date().getTime();
    const alertUpdated = currentTime - (drupalSettings.lastAlert * 1000);
    const notAccepted = prevAccepted === undefined;
    const prevAcceptedExpired = prevAccepted !== undefined && (currentTime - prevAccepted > expirationDuration || alertUpdated < expirationDuration);
    const triggerEndpoint = window.modal.getAttribute('data-endpoint');

    $('.closemodal').click(function() {
      window.modal.close();
      document.body.style.overflow = 'auto';
      localStorage.setItem('accepted', currentTime);
    });

    $('.openmodal').click(function() {
      window.modal.showModal();
      document.body.style.overflow = 'hidden';
      localStorage.removeItem('accepted');
    });

    if (triggerEndpoint) {
      $.get(triggerEndpoint + '/' + Date.now(), function(response) {
        if ((notAccepted || prevAcceptedExpired) && response.data[0]) {
          window.modal.showModal();
          document.activeElement.blur();
          document.body.style.overflow = 'hidden';
        }
      });
    }
    else if (notAccepted || prevAcceptedExpired) {
      window.modal.showModal();
      document.activeElement.blur();
      document.body.style.overflow = 'hidden';
    }
  }
})(jQuery, Drupal);